var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommissioned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 12.9896L21.4141 10.0833L21.7682 6.23958L18.0078 5.38542L16.0391 2.0625L12.4974 3.58333L8.95573 2.0625L6.98698 5.38542L3.22656 6.22917L3.58073 10.0833L1.03906 12.9896L3.58073 15.8958L3.22656 19.75L6.98698 20.6042L8.95573 23.9375L12.4974 22.4062L16.0391 23.9271L18.0078 20.6042L21.7682 19.75L21.4141 15.9062L23.9557 12.9896ZM19.8411 14.5312L19.2578 15.2083L19.3411 16.0938L19.5286 18.125L16.6745 18.7708L16.2161 19.5417L15.1849 21.2917L13.3307 20.4896L12.4974 20.1354L11.6745 20.4896L9.82031 21.2917L8.78906 19.5521L8.33073 18.7812L5.47656 18.1354L5.66406 16.0938L5.7474 15.2083L5.16406 14.5312L3.82031 13L5.16406 11.4583L5.7474 10.7812L5.65365 9.88542L5.46615 7.86458L8.32031 7.21875L8.77865 6.44792L9.8099 4.69792L11.6641 5.5L12.4974 5.85417L13.3203 5.5L15.1745 4.69792L16.2057 6.44792L16.6641 7.21875L19.5182 7.86458L19.3307 9.89583L19.2474 10.7812L19.8307 11.4583L21.1745 12.9896L19.8411 14.5312Z",
    fill: "#855ab0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5078 14.8229L8.09115 12.3958L6.54948 13.9479L10.5078 17.9167L18.1536 10.25L16.612 8.69792L10.5078 14.8229Z",
    fill: "#855ab0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissioned);
export default __webpack_public_path__ + "static/media/Commissioned.c9fe78d98aaf57ae5109e592429ab2fc.svg";
export { ForwardRef as ReactComponent };